import { UserProfileSchema, type UserProfile } from '@shared/schema/userProfile';
import { getDb } from './database';

const PROFILE_ID = 'local-profile' as const;

export async function getProfile(): Promise<UserProfile | null> {
  const db = await getDb();
  const profile = await db.get('profile', PROFILE_ID);
  return profile ?? null;
}

export async function saveProfile(input: { name: string; mobileNumber: string; address: string }): Promise<UserProfile> {
  const profile = UserProfileSchema.parse({ id: PROFILE_ID, ...input, updatedAt: Date.now() });
  const db = await getDb();
  await db.put('profile', profile);
  return profile;
}
